import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MarcaListado from "../../components/Marca/marcasList";
import {
  sagaGetMarcas,
  saveMarca,
  sagaEliminarMarca,
  sagaGetMarcaByNombre,
} from "../../reducers/marcasReducer/actions";
import { marcasDataSelector } from "../../selectors/marcasSelector";
import { usuarioSelector } from "../../selectors/sessionSelector";

class MarcaContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      marcas: {},
      allMarcas: {},
      modalData: {
        openModal: false,
        mensaje: "Está por eliminar una marca",
        labelModalOk: "Eliminar",
        handleModalOk: () => {},
        handleCloseModal: () => {},
      },
      usuarioCargado: false,
    };
    // busco los datos iniciales
    this.busqueda();
  }

  componentDidUpdate = (prevProps) => {
    if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuario.idRol === 4) {
          window.location.hash = "/Pedidos";
        }
      });
    }

    if (prevProps.marcas.marcas !== this.props.marcas.marcas) {
      this.setState({
        allMarcas: this.props.marcas.marcas,
        marcas: this.props.marcas.marcas,
      });
    }
  };

  busqueda() {
    this.props.sagaGetMarcas(this.state.nombre);
    this.props.saveMarca(undefined);
  }

  handleSearch = (nombre) => {
    if (!nombre || nombre.trim() === "") {
      this.setState({ marcas: this.state.allMarcas });
    } else {
      const filteredMarcas = this.state.allMarcas.filter((marca) =>
        marca.nombre.toLowerCase().includes(nombre.toLowerCase())
      );
      this.setState({ nombre, marcas: filteredMarcas });
    }
  };

  setModalData = (marca) => {
    this.setState({
      modalData: {
        openModal: true,
        mensaje: `Está por eliminar la marca ${marca.nombre}`,
        labelModalOk: "Eliminar",
        handleModalOk: () => {
          this.props.sagaEliminarMarca(marca.idMarca);
          this.setState({ modalData: { openModal: false } });
        },
        handleCloseModal: () => {
          this.setState({ modalData: { openModal: false } });
        },
      },
    });
  };

  render() {
    return (
      <MarcaListado
        marcas={this.state.marcas}
        mapToItem={(x) => ({
          nombre: x.nombre,
          codigo: x.codigo,
          onClick: x
            ? () => {
                this.props.saveMarca(x);
                this.props.history.push("/Marcas/Edit/" + x.idMarca);
              }
            : undefined,
          opciones: x
            ? [
                {
                  nombre: "Editar",
                  handler: () => {
                    this.props.saveMarca(x);
                    this.props.history.push("/Marcas/Edit/" + x.idMarca);
                  },
                },
                {
                  nombre: "Eliminar",
                  handler: () => {
                    this.setModalData(x);
                  },
                },
              ]
            : [],
          imagen: x.imagen ? x.imagen : require("../../images/default_rubro.png"),
        })}
        handleOnSave={() => {}}
        handleOnSearch={this.handleSearch}
        {...this.state.modalData}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetMarcas,
      saveMarca,
      sagaEliminarMarca,
      sagaGetMarcaByNombre,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    marcas: marcasDataSelector(state),
    usuario: usuarioSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MarcaContainer);
